import { instanceReadStatistics } from 'client/redux/instance/actionCreators';
import { INSTANCE_FATDI_READ_STATISTICS } from 'client/redux/fatdi/constants';

export const instanceFatdiReadStatistics = (id, statistic, query) => dispatch => {
  return dispatch(instanceReadStatistics(INSTANCE_FATDI_READ_STATISTICS, id, statistic, query));
};

